import React, { useState, useRef } from "react";
import styles from "./HomePage.module.css";
import { text } from "../../components/text";
import profileImg from "../../assets/images/profile.webp";

import { FaJava, FaReact, FaJs  } from "react-icons/fa";
import { FaFlutter } from "react-icons/fa6";
import { PiFileCSharp } from "react-icons/pi";
import { SiLua } from "react-icons/si";


function HomePage() {
  const [active, setActive] = useState("all");

  const [refs] = useState({
      hero: useRef(null),
      intro: useRef(null),
      projects: useRef(null),
      contact: useRef(null)
  });

  const Spacer = ({ children }) => {
    return (
      <div className={styles.spacer}>
        {children ? <p>{children}</p> : <span>&nbsp;</span>}
      </div>
    );
  };

  const scrollToSection = (section) => {
    refs[section]?.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      {/* ===== HERO SECTION ===== */}
      <header className={styles.heroContainer} ref={refs.hero}>
        <div className={styles.heroContent}>
            <div className={styles.heroBg} />

            <nav className={styles.navbar}>
                <ul className={styles.navbarList}>
                  {text.homepage.hero.nav.map((tab, index) => (
                    <li key={index} className={styles.navbarItem} onClick={() => scrollToSection(tab.id)}>
                      {tab.label}
                    </li>
                  ))}
                </ul>
            </nav>

            <div className={styles.heroLeft}>
                <p>{text.homepage.hero.nameEn}</p>
                <p>{text.homepage.hero.description}</p>
            </div>

            <div className={styles.heroRight}>
                <p>{text.homepage.hero.nameAr}</p>

                <img 
                    src={profileImg}
                    className={styles.profilePicture}
                />
            </div>
        </div>
      </header>

      <Spacer/>

      {/* ===== INTRODUCTION SECTION ===== */}
      <section id="into" className={styles.intoContainer} ref={refs.intro}>
        <div className={styles.intoContent}>
          <div className={styles.intoTitle}>{text.homepage.intro.title}</div>
          <p>{text.homepage.intro.subtitle}</p>
          
          <div className={styles.intoSubtitle}>
            {text.homepage.intro.intoSubtitle.map((a, index) => (
              <div key={index} className={styles.subtitleItem}>
                <div className={styles.subtitleTitle}>{a.title}</div>
                <p>{a.text}</p>
              </div>
            ))}
          </div>

          <div className={[styles.intoTitle, styles.titleSkills].join(' ')}>{text.homepage.intro.skillsTitle}</div>

          <div className={[styles.intoSubtitle, styles.subtitleSkills].join(' ')}>
            {text.homepage.intro.skills.map((skill, index) => (
              <div className={[styles.subtitleItem, styles.skillsItems].join(' ')}>
                <div className={styles.subtitleTitle}>{skill.title}</div>
                {skill.items.map((i, index) => (
                  <div className={styles.subtitleIcon}>
                    {i.icon}
                    <p>{i.title}</p>
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div className={[styles.intoSubtitle, styles.subtitleSkills].join(' ')}>
            <div className={[styles.subtitleItem, styles.othersSkillsItems].join(' ')}>
              <div className={styles.subtitleTitle}>{text.homepage.intro.otherSkills.title}</div>
              <div>
                {text.homepage.intro.otherSkills.items.map((i, index) => (
                  <div className={styles.subtitleIcon}>
                    {i.icon}
                    <p>{i.title}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Spacer>{text.homepage.projects.title}</Spacer>

      {/* ===== PROJECTS SECTION ===== */}
      <section id="projects" className={styles.projectsContainer} ref={refs.projects}>
        <div className={styles.projectsContent}>
          <div className={styles.projectsNavbar}>
            <div className={styles.projectsNavbarTabs}>
              {text.homepage.projects.filters.map((item, index) => (
                <button 
                  className={`${styles.projectsNavbarTab} ${active === item.id ? styles.active : ""}`}
                  onClick={() => setActive(item.id)}>{item.title}
                </button>
              ))}
            </div>
            <div className={styles.lineWrapper}>
              <div className={`${styles.line} ${styles[active]}`}></div>
            </div>
          </div>

          <div className={styles.projectsGrid}>
            {text.homepage.projects.projects.map((project, index) => (
              <div className={styles.projectCard}>
                <img className={styles.img} src={project.logo}/>
                <p className={styles.title}>{project.title}</p>
                <p className={styles.des}>{project.description}</p>
                <div className={styles.actions}>
                  {project.links.map((link, index) => (
                    <button className={styles.actionBtn} onClick={() => window.open(link.link, '_blank')}>{link.title}</button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Spacer>{text.homepage.contact.title}</Spacer>

      {/* ===== CONTACT SECTION ===== */}
      <section id="contact" className={styles.contactContainer} ref={refs.contact}>
        <div className={styles.contactContent}>
          <div className={styles.contactTitle}>{text.homepage.contact.subtitle}</div>
          <p>{text.homepage.contact.description}</p>
          <div className={styles.contactMethods}>
            <button className={styles.contactBtn} onClick={() => window.location.href = 'mailto:mouner.shami@gmail.com'}>Email</button>
            <button className={styles.contactBtn} onClick={() => window.open('https://www.linkedin.com/in/mounersh/', '_blank')}>LinkedIn</button>
            <button className={styles.contactBtn} onClick={() => window.open('https://github.com/mouners', '_blank')}>GitHub</button>
          </div>
        </div>
      </section>
    </>
  );
}

export default HomePage;
